import React, { useState, useEffect } from "react";
import { tokenValidation } from "../../helper/customizedHooks";
import AdminPage from "./AdminPage";
import OrdersAdminPage from "./Orders/OrdersAdminPage";
import { getOptions } from "../../helper/api";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from "react-router-dom";
import LicensePage from "./LicensePage";
import OrderNoSapId from "./OrderNoSapId";
/**
 * Admin Main Page
 * @author Poornna Aiswarya Ganeshan
 * @version 1.0
 */

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    table: {
        minWidth: 500,
    },
    tableWrapper: {
        overflow: 'auto',
    },
});

const AdminMainPage = ({
    history,
    match,
    email,
    idToken,
}) => {

    const [tabValue, setTabValue] = React.useState(0);
    const [reload, setReload] = useState(false);


    const mapUrlToTab = {
        adminAuthControl: 0,
        adminLicenseManagement: 1,
        adminOrderHandling: 2,
        adminOrderFollowup: 3,
    };

    //Add the idToken to the options header for api calls.
    getOptions.headers["Authorization"] = idToken;

    const eId = email === undefined ? undefined : email.split("@")[0];

    useEffect(() => {
        tokenValidation();
        setTabValue(
            mapUrlToTab[match.params.type] ? mapUrlToTab[match.params.type] : 0
        );
    }, [eId, reload, match.params.type])

    const handleChange = (event, newValue) => {
        history.push(
            `/admin/${(newValue === 0 && "adminAuthControl") ||
            (newValue === 2 && "adminOrderHandling")}`
        );
        setTabValue(newValue);
    };

    return (
        <div style={{ height: "100%" }}>
            {/* Authorization Control */}
            {
                tabValue === 0 && (
                    <div>
                        <AdminPage />
                    </div>
                )
            }
            {/* license management */}
            {
                tabValue === 1 && (
                    <div>
                        <LicensePage />
                    </div>
                )
            }

            {/* Order Handling */}
            {
                tabValue === 2 && (
                    <div>
                        <OrdersAdminPage />
                    </div>
                )
            }
            {
                tabValue === 3 && (
                    <div>
                        <OrderNoSapId />
                    </div>
                )
            }
        </div>
    )
}

AdminMainPage.propTypes = {
    /**
     * Current users email
     */
    email: PropTypes.string,
};


const MSTP = (state) => ({
    email: state.auth.userDetails.email,
    idToken: state.auth.idToken,

});

export default connect(MSTP)(withRouter(withStyles(styles)(AdminMainPage)));